import { useEffect, useState } from 'react'

interface LoadingScreenProps {
  isLoading: boolean
  onComplete?: () => void
}

export default function LoadingScreen({ isLoading, onComplete }: LoadingScreenProps) {
  const [isVisible, setIsVisible] = useState(isLoading)

  useEffect(() => {
    if (isLoading) {
      setIsVisible(true)
      return
    }

    const timer = setTimeout(() => {
      setIsVisible(false)
      onComplete?.()
    }, 300)
    return () => clearTimeout(timer)
  }, [isLoading, onComplete])

  if (!isVisible) return null

  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-white transition-opacity duration-300 ${
        isLoading ? 'opacity-100' : 'opacity-0'
      }`}
    >
      <div className="flex flex-col items-center gap-6">
        <img
          src="/images/logo/logo_petunya_borek.png"
          alt="Petunya Börek"
          className="h-16 w-auto"
        />
        <div className="h-1 w-40 overflow-hidden rounded-full bg-neutral-200">
          <div className="h-full w-1/2 animate-[loading-slide_1s_ease-in-out_infinite] rounded-full bg-primary-600" />
        </div>
      </div>

      <style>{`
        @keyframes loading-slide {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(320%); }
        }
      `}</style>
    </div>
  )
}
